import { createSelector } from "reselect";
import values from "lodash/values";

// Base state selector
const ruleState = (state) => state?.globalData?.rules || {};

// General selector for all rules
export const rulesSelector = createSelector(ruleState, (rules) => values(rules));

// This selector checks if any rule in the state has the type "create-event"
// and is associated with a subject containing the given templateId.
export const isEventTemplateAssociatedWithRules = (templateId) =>
	createSelector([ruleState], (rules) => {
		return values(rules).some(
			(rule) => rule.type === "create-event" && rule.subject?.some((subject) => subject?.template === templateId)
		);
	});
